import { eIssueType } from "../data/Issues";
import { tTeamMember } from "../data/Team";

export const getBorderColor = (mainElement: string): string => {
    switch (mainElement) {
        case 'API':
            return 'green'; // Color for Backend
        case 'UI':
            return 'blue'; // Color for UI
        case 'Db':
            return 'orange'; // Color for Database
        default:
            return 'gray'; // Default color if none matches
    }
};

export const getIssueIcon = (type: eIssueType): string => {
    switch (type) {
        case eIssueType.Bug:
            return '🐛';
        case eIssueType.Enhancement:
            return '🎯';
        case eIssueType.ServiceRequest:
            return '❓';
        default:
            return '';
    }
}

export function sortArray<T>(arr: T[], property: keyof T): T[] {
    // Return a sorted copy of the array
    return arr.sort((a, b) => {
        const aValue = a[property];
        const bValue = b[property];

        // If both values are strings, use localeCompare for alphabetical sorting
        if (typeof aValue === 'string' && typeof bValue === 'string') { // string comparison
            return aValue.localeCompare(bValue);
        }
        // If both values are numbers, subtract them
        else if (typeof aValue === 'number' && typeof bValue === 'number') { // number comparison
            return aValue - bValue;
        }
        // Fallback: convert both to strings and compare
        else {
            return String(aValue).localeCompare(String(bValue));
        }
    });
}

export function randomizeTeamLevels(team: tTeamMember[]): tTeamMember[] {
    // Define the skill levels to assign: one at 1, two at 0.75, one at 0.5
    const skillLevels = [0.5, 0.75, 0.75, 1];
    
    // Shuffle the skill levels array using Fisher-Yates algorithm
    const shuffledLevels = [...skillLevels];
    for (let i = shuffledLevels.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledLevels[i], shuffledLevels[j]] = [shuffledLevels[j], shuffledLevels[i]];
    }
    
    // Create a new team array with randomized levels only for currently employed members
    let levelIndex = 0;
    return team.map((member) => ({
        ...member,
        level: member.currentlyEmployed ? shuffledLevels[levelIndex++] : member.level
    }));
}

export function getWeekdayFromSprintProgress(sprintProgress: number): string {
    // Map sprint progress (1-10) to weekdays (Monday-Friday)
    // Each progress step is a different day: 1=Monday, 2=Tuesday, 3=Wednesday, 4=Thursday, 5=Friday, 6=Monday, etc.
    const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
    const dayIndex = (sprintProgress - 1) % weekdays.length;
    return weekdays[dayIndex];
}